import { z } from 'zod';
import { emailSchema, objectIdSchema } from './common.js';
import { portalLocaleSchema } from './locale.js';
export const requestLoginLinkSchema = z
    .object({ email: emailSchema, locale: portalLocaleSchema.optional() })
    .strict();
/** 256-bit tokens, base64url without padding. */
export const loginTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/, 'invalid token');
export const verifyLoginLinkSchema = z.object({ token: loginTokenSchema }).strict();
export const updatePortalMeSchema = z
    .object({
    name: z.string().trim().min(1).max(120).optional(),
    locale: portalLocaleSchema.optional(),
})
    .strict();
/** Switch the session to another entity the same person has access to. */
export const switchEntitySchema = z.object({ partnerId: objectIdSchema }).strict();
